export class BaseLogDocument {
    public error: string = '';
    public data: string = '';
    public location: string = '';

    constructor(params?: Partial<BaseLogDocument>) {
        if (!!params) {
            this.error = params.error || this.error;
            this.data = params.data || this.data;
            this.location = params.location || this.location;
        }
    }
}
